import { __module as isObject } from '../../../../../_virtual/is-object.js';

var hasRequiredIsObject;

function requireIsObject () {
	if (hasRequiredIsObject) return isObject.exports;
	hasRequiredIsObject = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});

		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

		exports.default = isObject;
		/**
		 * Check if a value is an object
		 * @ignore
		 * @param {*} value
		 * @return {boolean}
		 */
		function isObject(value) {
		  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
		}
		module.exports = exports['default'];
		
	} (isObject, isObject.exports));
	return isObject.exports;
}

export { requireIsObject as __require };
